import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pc",
  "use": "icon-pc-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-pc\"><defs><style type=\"text/css\"></style></defs><path d=\"M125.5 381.8L65.2 319V135.5s0-64.1 62.8-64.1h763.9s64.1 0 62.8 64.1v560.4s0 62.8-62.8 62.8h-260l2.5 130.7-194.8-193.5h452.3V135.5H125.5v246.3z m0 0\" p-id=\"3954\" /><path d=\"M244.9 494.8V233.5h522.7v364.4h-426zM634.4 889.4h175.9s46.5 30.2 0 60.3H694.7l-60.3-60.3z\" p-id=\"3955\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol